import { Box, Text, Tag, IconAwardRibbon } from '@zillow/constellation';
import React from 'react';

import type { ExpertiseProps } from './AuthorPage.types';

/**
 * Displays a list of expertise tags for the author.
 */
const Expertise: React.FC<ExpertiseProps> = ({ expertise }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '$spacing.xs',
                '@media $md': {
                    alignItems: 'center',
                },
            }}
        >
            <Text as="h5" fontType="h5" fontColor="blue600">
                <IconAwardRibbon fontColor="blue600" /> Expertise
            </Text>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '$spacing.xs',
                    '@media $md': {
                        justifyContent: 'center',
                    },
                    '@media $lg': {
                        justifyContent: 'flex-start',
                    },
                }}
            >
                {expertise.map((item, index) => (
                    <Tag key={`${item}-${index}`} appearance="info" size="sm">
                        {item}
                    </Tag>
                ))}
            </Box>
        </Box>
    );
};

export default Expertise;
